import { render, staticRenderFns } from "./Product_LowCost.vue?vue&type=template&id=248f8d39&scoped=true&"
import script from "./Product_LowCost.vue?vue&type=script&lang=js&"
export * from "./Product_LowCost.vue?vue&type=script&lang=js&"
import style0 from "./Product_LowCost.vue?vue&type=style&index=0&id=248f8d39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f8d39",
  null
  
)

export default component.exports